'use client';
import styled from 'styled-components';
import { colors, gradients } from '@/styles';
import Tag from '@/ui/Tag';

export const EntityStatusTag = styled(Tag)<{ $status: string }>`
  border: 1.5px solid ${colors.primary.black};
  width: 1rem;
  height: 1rem;
  padding: 2px;
  /* font-weight: 600; */
  align-items: center !important;
  justify-content: center;
  border-radius: 2px;
  fill: ${(props) => colors.semantic.diff[props.$status as keyof typeof colors.semantic.diff]?.indicator};
  color: ${(props) => colors.semantic.diff[props.$status as keyof typeof colors.semantic.diff]?.indicator};
  border-color: ${(props) => colors.semantic.diff[props.$status as keyof typeof colors.semantic.diff]?.indicator};
  background-color: ${(props) => colors.semantic.diff[props.$status as keyof typeof colors.semantic.diff]?.background};
  /* background-color: ${colors.primary.white}; */

  svg {
    stroke-width: 3px;
  }
`;
